// src/utils/dateHelpers.js
//
// Sprint 2c-1 commit 9c74841: isoToday, addYearsIso, formatSubDate established
// (prototype 6147-6157).
// Sprint 2c-2a (this commit): additive expansion with 2 helpers
//   (relative-day countdown, locale-formatted reset-date).

export const isoToday = () => new Date().toISOString().slice(0, 10);

export const addYearsIso = (iso, years) => {
    const d = new Date(iso);
    d.setFullYear(d.getFullYear() + years);
    return d.toISOString().slice(0, 10);
};

export const formatSubDate = (iso) => {
    if (!iso) return '—';
    try { return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); }
    catch { return iso; }
};

// Sprint 2c-2a additive
// Migrated verbatim from prototype/between-the-lines-v2.html lines 6158-6163.
export const daysUntil = (iso) => {
    if (!iso) return null;
    const target = new Date(iso).getTime();
    const now = Date.now();
    return Math.ceil((target - now) / (1000 * 60 * 60 * 24));
};

// Migrated verbatim from prototype/between-the-lines-v2.html lines 5738-5740.
export const formatResetDate = (d) => {
    try { return new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); } catch { return ''; }
};
